import type { Integration } from "../../../../sub-modules/management/types";

const MANAGE_INTEGRATIONS_BASE_KEY = "manageIntegrations";
const INTEGRATION_STATUS_KEY = "integrationStatus";
const DISCONNECT_INTEGRATION_KEY = "disconnect";

type ManageIntegrationsQueryKey = {
    all: () => readonly string[];
    integrationStatus: () => readonly string[];
    byIntegration: (integration: Integration) => readonly string[];
    disconnectIntegration: () => readonly string[];
};

export const manageIntegrationsQueryKeys: ManageIntegrationsQueryKey = {
    all() {
        return [MANAGE_INTEGRATIONS_BASE_KEY] as const;
    },

    integrationStatus() {
        return [...manageIntegrationsQueryKeys.all(), INTEGRATION_STATUS_KEY] as const;
    },

    byIntegration(integration: Integration) {
        return [...manageIntegrationsQueryKeys.integrationStatus(), integration] as const;
    },

    disconnectIntegration() {
        return [...manageIntegrationsQueryKeys.integrationStatus(), DISCONNECT_INTEGRATION_KEY] as const;
    },
};
